import { Messages } from '../../../constants';

const validation = {
  clientSearch: {
    presence: {
      message: Messages.RequiredClientValidationMessage,
      allowEmpty: false
    }
  },
  agency: {
    presence: {
      message: Messages.RequiredAgencyValidationMessage,
      allowEmpty: false
    }
  },
  salesType: {
    presence: {
      message: Messages.RequiredSalesTypeValidationMessage,
      allowEmpty: false
    }
  },
  mainVehicle: {
    presence: {
      message: Messages.RequiredMainVehicleValidationMessage,
      allowEmpty: false
    }
  },
  salesOrigin: {
    presence: {
      message: Messages.RequiredSalesOriginValidationMessage,
      allowEmpty: false
    }
  },
 
  beginDate: {
    presence: {
      message: Messages.RequiredBeginDateValidationMessage,
      allowEmpty: false
    }
  },
  endDate: {
    presence: {
      message: Messages.RequiredEndDateValidationMessage,
      allowEmpty: false
    }
  },
  table: {
    presence: {
      message: Messages.RequiredTableValidationMessage,
      allowEmpty: false
    }
  },
  paymentType: {
    presence: {
      message: Messages.RequiredPaymentTypeValidationMessage,
      allowEmpty: false
    }
  },
  totalAmount: {
    presence: {
      message: Messages.RequiredAmountValidationMessage,
      allowEmpty: false
    },
    numericality: {
      greaterThan: 0,
      message: Messages.RequiredAmountValidationMessage
    }
  },
  nature: {
    presence: {
      message: Messages.RequiredNatureValidationMessage,
      allowEmpty: false
    }
  },

  saveSharepoint: {
    presence: {
      message: Messages.RequiredSaveSharepointValidationMessage,
      allowEmpty: false
    }
  },
  justification: {
    presence: {
      message: Messages.RequiredJustificationSharepointValidationMessage,
      allowEmpty: false
    }
  },
  discount: {
    presence: (value, attributes) => {
      if (
        attributes.nature != null &&
        ['PERMUTA NAO PATRIMONIAL', 'PERMUTA PATRIMONIAL'].indexOf(
          attributes.nature.nome
        ) === -1
      ) {
        return {
          message: Messages.RequiredDiscountValidationMessage,
          allowEmpty: false
        };
      }
      return false;
    }
  }
};

export default validation;
